// CacheKey 3898aa60f3a01dee92136c86081a241a
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { request } from '@services/EvolveApiService'

export default {
  search: options =>
    request('post', '/vue/outreach_programs/search', options),

  searchFilterOptions: options =>
    request('post', '/vue/outreach_programs/search_filter_options', options),

  archivedActions: options =>
    request('get', '/vue/outreach_programs/:id/archived_actions', options),

  playAudio: options =>
    request('get', '/vue/outreach_programs/:id/play_audio', options),

  copy: options =>
    request('post', '/vue/outreach_programs/:id/copy', options),

  previewGeminiTtsAudio: options =>
    request('get', '/vue/outreach_programs/preview_gemini_tts_audio', options),

  programsToCopyCriteria: options =>
    request('get', '/vue/outreach_programs/:id/programs_to_copy_criteria', options),

  pause: options =>
    request('post', '/vue/outreach_programs/:id/pause', options),

  resume: options =>
    request('post', '/vue/outreach_programs/:id/resume', options),

  start: options =>
    request('post', '/vue/outreach_programs/:id/start', options),

  stop: options =>
    request('post', '/vue/outreach_programs/:id/stop', options),

  export: options =>
    request('post', '/vue/outreach_programs/:id/export', options),

  reevaluateEnrollments: options =>
    request('post', '/vue/outreach_programs/:id/reevaluate_enrollments', options),

  showActivationCriteria: options =>
    request('get', '/vue/outreach_programs/:id/show_activation_criteria', options),

  showExclusionCriteria: options =>
    request('get', '/vue/outreach_programs/:id/show_exclusion_criteria', options),

  outreachProgramsWithNames: options =>
    request('post', '/vue/outreach_programs/outreach_programs_with_names', options),

  outreachActionsWithNames: options =>
    request('post', '/vue/outreach_programs/outreach_actions_with_names', options),

  registerNumber: options =>
    request('post', '/vue/outreach_programs/register_number', options),

  confirmPhoneNumber: options =>
    request('put', '/vue/outreach_programs/confirm_phone_number', options),

  programIdsWithHelpSupport: options =>
    request('get', '/vue/outreach_programs/program_ids_with_help_support', options),

  shortCodesAutocomplete: options =>
    request('get', '/vue/outreach_programs/:id/short_codes_autocomplete', options),

  create: options =>
    request('post', '/vue/outreach_programs', options),

  new: options =>
    request('get', '/vue/outreach_programs/new', options),

  edit: options =>
    request('get', '/vue/outreach_programs/:id/edit', options),

  get: options =>
    request('get', '/vue/outreach_programs/:id', options),

  update: options =>
    request('patch', '/vue/outreach_programs/:id', options),

  destroy: options =>
    request('delete', '/vue/outreach_programs/:id', options),
}
